import {
  DefaultPage,
  ExternalApiTabBar,
  ExternalZapierCreate,
  ExternalZapierUpdate,
  Appwrite,
  Xano,
  Supabase,
  Xata,
  Directus,
  Airtable,
  Salesforce,
  ExternalSourceApiTabBar,
} from './';
import ChatGpt from './chat-gpt-api/ChatGpt';
import ChatGptEdit from './chat-gpt-api/ChatGptEdit';
import Zapier from './zapier/Zapier';

export default {
  path: 'externalapi/:version/v',
  name: 'ExternalApi',
  childRoutes: [
    {
      path: ':projectId',
      name: 'External API',
      component: DefaultPage,
      isIndex: true,
      isPrivate: true,
    },
    {
      path: ':projectId/create',
      name: 'Create External API',
      component: ExternalApiTabBar,
      isPrivate: true,
    },
    {
      path: ':projectId/edit/:externalApiId',
      name: 'ExternalApi tab bar',
      component: ExternalApiTabBar,
      isPrivate: true,
    },
    { path: ':projectId/zapier', name: 'Zapier', component: Zapier, isPrivate: true },
    {
      path: ':projectId/zapier/create',
      name: 'External Zapier Create',
      component: ExternalZapierCreate,
      isPrivate: true,
    },
    {
      path: ':projectId/zapier/:externalApiId/update',
      name: 'External Zapier Update',
      component: ExternalZapierUpdate,
      isPrivate: true,
    },
    { path: ':projectId/appwrite', name: 'Appwrite', component: Appwrite, isPrivate: true },
    {
      path: ':projectId/xano',
      name: 'Xano',
      component: Xano,
      isPrivate: true,
    },
    { path: ':projectId/chatGpt', name: 'ChatGpt', component: ChatGpt, isPrivate: true },
    {
      path: ':projectId/chatGpt/create',
      name: 'External ChatGpt Create',
      component: ChatGptEdit,
      isPrivate: true,
    },
    {
      path: ':projectId/chatGpt/:externalApiId/update',
      name: 'External ChatGpt Update',
      component: ChatGptEdit,
      isPrivate: true,
    },
    {
      path: ':projectId/supabase',
      name: 'Supabase',
      component: Supabase,
      isPrivate: true,
    },
    {
      path: ':projectId/xata',
      name: 'Xata',
      component: Xata,
      isPrivate: true,
    },
    {
      path: ':projectId/directus',
      name: 'Directus',
      component: Directus,
      isPrivate: true,
    },
    {
      path: ':projectId/airtable',
      name: 'Airtable',
      component: Airtable,
      isPrivate: true,
    },
    {
      path: ':projectId/salesforce',
      name: 'Salesforce',
      component: Salesforce,
      isPrivate: true,
    },

    {
      path: ':projectId/edit-external-source/:externalApiId',
      name: 'ExternalSourceApiTabBar',
      component: ExternalSourceApiTabBar,
      isPrivate: true,
    },
  ],
};
